import styled, { css } from 'styled-components';
import GatsbyImg from 'gatsby-image';
import { hideVisually } from 'polished';

import { lessThan } from '@utils/mediaQuery';
import { speed } from '@styles/animation';

const breakpoint = 360;

const wrapperStyle = css`
  position: relative;

  /* max-width: 664px; */

  margin-right: auto;
  margin-left: auto;
`;

const containerStyle = css`
  display: flex;

  margin: 0;
  padding: 0;

  -khtml-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
`;

export const viewportStyle = css`
  width: 100%;
  overflow: hidden;

  &.is-draggable {
    cursor: move;
    cursor: grab;
  }

  &.is-dragging {
    cursor: grabbing;
  }
`;

export const CarouselWrapper = styled.div`
  ${wrapperStyle}
`;

export const CarouselContainer = styled.ul`
  ${containerStyle}

  list-style: none;
`;

export const Slide = styled.li`
  position: relative;

  box-sizing: content-box;

  min-width: 100%;
  padding-right: ${15 / 22}rem;
  padding-left: ${15 / 22}rem;
`;

export const SlideInner = styled.figure`
  position: relative;

  margin: 0;

  /* max-height: 608px; */

  overflow: hidden;
`;

export const SlideImg = styled(GatsbyImg)`
  width: auto;
  min-width: 100%;
  max-width: none;
  min-height: 308px;
`;

export const SlideCaption = styled.figcaption`
  ${hideVisually}
`;

export const ThumbWrapper = styled.div`
  ${wrapperStyle}

  padding-top: 0;
`;

export const ThumbContainer = styled.ul`
  ${containerStyle}

  margin-top: ${30 / 22}rem;
  margin-right: -${15 / 22}rem;
  margin-left: -${15 / 22}rem;

  list-style: none;
  cursor: default;
`;

export const ThumbSlide = styled.li`
  position: relative;

  min-width: calc(100% / 3);
  padding-right: ${15 / 22}rem;
  padding-left: ${15 / 22}rem;

  ${lessThan(breakpoint)} {
    padding-right: ${9 / 2 / 16}rem;
    padding-left: ${9 / 2 / 16}rem;
  }
`;

export const ThumbSlideInner = styled.button`
  position: relative;

  display: block;
  width: 100%;

  /* max-height: 139px; */

  margin: 0;
  padding: 0;

  overflow: hidden;

  background-color: transparent;
  border: 0;

  cursor: pointer;

  touch-action: manipulation;
`;

export const Thumbnail = styled(GatsbyImg)`
  min-width: 100%;
  max-width: none;
  min-height: 100%;
  margin: auto;

  ::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: ${({ theme }) => theme.colors.white};

    opacity: ${({ selected }) => (selected ? '0' : '0.5')};

    @media (prefers-reduced-motion: no-preference) {
      transition: opacity ${speed.fast};
    }

    content: '';
  }
`;
